class DaayraaSizeChart extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.dialog = this.querySelector('dialog');
    this.opener = this.querySelector('[data-size-chart-open]');
    if (!this.dialog || !this.opener || typeof this.dialog.showModal !== 'function') return;

    this.opener.setAttribute('aria-haspopup', 'dialog');
    this.opener.setAttribute('aria-controls', this.dialog.id);
    const images = Array.from(this.dialog.querySelectorAll('img'));
    const status = this.querySelector('[data-size-chart-status]');
    const updateImageStatus = () => {
      if (!status) return;
      const loading = images.some((image) => !image.complete);
      const failed = images.some((image) => image.complete && image.naturalWidth === 0);
      status.hidden = !loading && !failed;
      status.textContent = loading ? 'Loading size chart…' : 'If the chart cannot load, open the full-size image below.';
    };
    const warmImages = () => {
      images.forEach((image) => { image.loading = 'eager'; });
      updateImageStatus();
    };
    images.forEach((image) => {
      image.addEventListener('load', updateImageStatus, { signal });
      image.addEventListener('error', updateImageStatus, { signal });
    });
    this.opener.addEventListener('pointerenter', warmImages, { once: true, signal });
    this.opener.addEventListener('focus', warmImages, { once: true, signal });
    this.opener.addEventListener('click', (event) => {
      // Preserve normal new-tab behaviour and the image link when enhancement fails.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (this.dialog.open) return;
      warmImages();
      this.dialog.showModal();
      document.documentElement.classList.add('daayraa-size-chart-open');
    }, { signal });

    this.querySelector('[data-size-chart-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
    this.dialog.addEventListener('click', (event) => {
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
        this.dialog.close();
      }
    }, { signal });
    this.dialog.addEventListener('close', () => {
      this.unlockScroll();
      if (this.opener.isConnected) this.opener.focus({ preventScroll: true });
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    if (this.dialog?.open) this.dialog.close();
    this.unlockScroll();
  }

  unlockScroll() {
    if (!document.querySelector('.daayraa-size-chart__dialog[open]')) {
      document.documentElement.classList.remove('daayraa-size-chart-open');
    }
  }
}

if (!customElements.get('daayraa-size-chart')) {
  customElements.define('daayraa-size-chart', DaayraaSizeChart);
}
